import React from 'react'
import { FormattedMessage } from 'react-intl'
import Clickable from '../Clickable'
import useToggle from 'hooks/useToggle'
import ReserveForZeroPolicyModal from './ReserveForZeroPolicyModal'
import LineClockDollarIcon from 'LuxKit/Icons/line/LineClockDollarIcon'
import Pill from 'LuxKit/Pill'

function ReserveForZeroTag() {
  const [isOpen, , onOpen, onClose] = useToggle()

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    onOpen()
  }

  return <>
    <Clickable onClick={handleClick}>
      <Pill kind="tertiary" variant="primary" startIcon={<LineClockDollarIcon />}>
        <FormattedMessage
          id="NKIxXikd5B"
          defaultMessage="Reserve now for free"
          description="Pill text for reserve for zero tag in the reserve for zero tag and tooltip section"
        />
      </Pill>
    </Clickable>
    <ReserveForZeroPolicyModal
      isOpen={isOpen}
      onClose={onClose}
    />
  </>
}

export default ReserveForZeroTag
